import React from "react";

export const Faq = () => {
  return (
    <div
      className="WordSection1"
      style={{ background: "white", padding: "10px 20px" }}
    >
      <p className="MsoNormal" align="center" style={{ textAlign: "center" }}>
        <b>
          <span lang="EN" style={{ fontSize: "20.0pt", lineHeight: "115%" }}>
            FAQs
          </span>
        </b>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&gt; Sign Up and Log In</span>
        </b>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&nbsp;</span>
        </b>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">How do I sign up? </span>
        </i>
      </p>

      <ol style={{ marginTop: "0in" }} start="1" type="1">
        <li className="MsoNormal">
          <span lang="EN">
            Click the "Sign In" button on the upper right corner of site
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">Click “Sign Up” at the bottom of the pop-up</span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Fill in the information to create your account and click Sign Up
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            We will send a verification code to your email to finalize the
            account creation process
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">Log in and you’re ready to explore</span>
        </li>
      </ol>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">How do I log in?</span>
        </i>
      </p>

      <ol style={{ marginTop: "0in" }} start="1" type="1">
        <li className="MsoNormal">
          <span lang="EN">
            Click the "Sign In" button on the upper right corner of our website
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">Fill in your user name and password</span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">Click Sign In</span>
        </li>
      </ol>

      <p className="MsoNormal" style={{ background: "white" }}>
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal" style={{ background: "white" }}>
        <i>
          <span lang="EN" style={{ color: "black" }}>
            Issues creating an account?{" "}
          </span>
        </i>
      </p>

      <p className="MsoNormal" style={{ background: "white" }}>
        <span lang="EN" style={{ color: "black" }}>
          Try refreshing the page or try again later. If the problem persists,
          please contact
          <a href="mailto:admin@gothruhike.com">
            <span style={{ color: "#1155CC" }}>&nbsp;admin@gothruhike.com&nbsp;</span>
          </a>
          with a description or screenshot of the error
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">How do I edit my user profile?</span>
        </i>
      </p>

      <ol style={{ marginTop: "0in" }} start="1" type="1">
        <li className="MsoNormal">
          <span lang="EN">
            Click your account dropdown on the upper right corner of the page
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">Click “View Profile”</span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Adjust your name, email address, country, about me, as well as your
            profile picture{" "}
          </span>
        </li>
      </ol>

      <p className="MsoNormal" style={{ background: "white" }}>
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal" style={{ background: "white" }}>
        <i>
          <span lang="EN" style={{ color: "black" }}>
            Delete account
          </span>
        </i>
      </p>

      <ol style={{ marginTop: "0in" }} start="1" type="1">
        <li className="MsoNormal" style={{ background: "white" }}>
          <span lang="EN" style={{ color: "black" }}>
            Click your account dropdown on the upper right corner of the page
          </span>
        </li>
        <li className="MsoNormal" style={{ background: "white" }}>
          <span lang="EN" style={{ color: "black" }}>
            Click Delete Account and follow the prompts. Thank you for trying us
            out!
          </span>
        </li>
      </ol>

      <p className="MsoNormal" style={{ background: "white" }}>
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&gt; General FAQ</span>
        </b>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">How does Thruhike’s search work*?</span>
        </i>
      </p>

      <ol style={{ marginTop: "0in" }} start="1" type="1">
        <li className="MsoNormal">
          <span lang="EN">
            Always make sure the location filter (upper left) is set to the area
            you’d like to search in or leave it on “Explore” to search our
            entire database of places and products
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Once your location is set, search any term or terms that comes to
            mind relating to the type of place or product you’d like to find
            (i.e. “cozy restaurant” or “retro bar”)
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            As time goes on, we will get better and better at curating and
            showing you the places and products that best match your tastes and
            preferences when you search.
          </span>
        </li>
      </ol>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal" style={{ marginLeft: ".5in" }}>
        <span lang="EN">
          *Please note that when you are on the Trail Lists section of the site,
          you will be searching Trail Lists specifically.
        </span>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&nbsp;</span>
        </b>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">What’s a Trail List? </span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          A Trail List is a list of places and products. They usually follow a
          theme i.e. “Weekend in Los Angeles” or “Candlelit Evenings.” Our
          Thruhike Scout team releases frequent curated Trail Lists on our site
          to help you discover the best experiences and itineraries. Users are
          also able to create their own Trail Lists by clicking “Add to Trail”
          underneath place and product profiles or by hitting the Trail List
          Icon (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.0833 3.33333C11.1666 3.41667 11.1666 3.41667 11.1666 4C11.1666 4.25 11.1666 4.5 11.1666 4.58333C11.1666 4.58333 11.4999 4.58333 13.4166 4.66667H15.5833L16.0833 5.25C16.4999 5.58333 16.6666 5.83333 16.6666 5.83333C16.6666 5.83333 16.4999 6.08333 16.1666 6.5L15.6666 7.08333H13.4999C11.5833 7.08333 11.2499 7.08333 11.2499 7.16667C11.2499 7.16667 11.2499 7.58333 11.2499 8.16667C11.2499 9 11.2499 9.08333 11.2499 9.16667C11.2499 9.16667 11.3333 9.25 11.9166 9.25H12.5833L12.6666 9.16667C12.7499 9.25 12.7499 9.25 12.7499 10.3333C12.7499 11.0833 12.7499 11.5 12.7499 11.5C12.5833 11.6667 12.5833 11.6667 11.8333 11.6667C11.3333 11.6667 11.1666 11.6667 11.1666 11.6667C11.1666 11.6667 11.1666 12.25 11.1666 14.0833V16.5L11.0833 16.5833V16.6667H9.99995H8.99995L8.91661 16.5833L8.83328 16.5V14.1667C8.83328 12.3333 8.83328 11.75 8.83328 11.75C8.83328 11.75 8.24995 11.75 6.58328 11.75H4.41661L3.91661 11.1667C3.58328 10.75 3.33328 10.5 3.33328 10.4167V10.3333C3.33328 10.3333 3.58328 10 3.83328 9.66667L4.33328 9.08333H6.49995C8.49995 9.08333 8.66661 9.08333 8.74995 9.08333C8.83328 9.08333 8.83328 9 8.83328 8.08333C8.83328 7.25 8.83328 7.16667 8.83328 7.08333C8.83328 7.08333 8.66661 7.08333 8.16661 7.08333C7.58328 7.08333 7.49995 7.08333 7.41661 7H7.33328V5.83333V4.66667L7.41661 4.58333L7.49995 4.5H8.16661C8.74995 4.5 8.83328 4.5 8.83328 4.5C8.83328 4.5 8.83328 4.41667 8.83328 3.91667C8.83328 3.41667 8.83328 3.41667 8.91661 3.33333H8.99995H9.99995H11.0833ZM11.7499 1.66667H11.0833H9.99995H8.99995H8.24995L7.74995 2.16667V2.25C7.49995 2.41667 7.33328 2.66667 7.33328 2.91667H6.74995L6.24995 3.33333V3.41667L6.16661 3.5L5.66661 4V4.66667V5.83333V7V7.5H4.33328H3.58328L3.08328 8L2.58328 8.58333C1.99995 9.25 1.83328 9.41667 1.74995 9.66667C1.58328 10.1667 1.58328 10.6667 1.83328 11.1667C1.91661 11.3333 1.91661 11.4167 2.58328 12.1667L3.08328 12.75L3.66661 13.3333H4.41661H6.58328C6.74995 13.3333 6.91661 13.3333 7.16661 13.3333C7.16661 13.6667 7.16661 13.9167 7.16661 14.1667V16.5833V17.25L7.66661 17.75L7.74995 17.8333L7.83328 17.9167L8.24995 18.3333H8.91661H9.99995H11.0833H11.7499L12.2499 17.8333L12.3333 17.75L12.4166 17.6667L12.9166 17.1667V16.5V14.1667C12.9166 13.9167 12.9166 13.6667 12.9166 13.3333C13.4166 13.25 13.9166 13 14.2499 12.3333C14.4166 11.9167 14.4166 11.6667 14.4166 10.5C14.4166 9.66667 14.4166 9.16667 14.3333 8.91667H15.7499H16.4999L16.9999 8.33333L17.4999 7.75C17.9999 6.91667 18.3333 6.5 18.3333 5.83333C18.3333 5.16667 17.9999 4.75 17.4166 4.08333L16.9166 3.5L16.4166 2.91667H15.6666H13.4999C13.2499 2.91667 12.9999 2.91667 12.7499 2.91667C12.6666 2.66667 12.4999 2.41667 12.3333 2.25L12.2499 2.16667L11.7499 1.66667Z"
              fill="#66737F"
            />
          </svg>
          ) on the upper right of the screen.
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">
            I don’t see one of my favorite places or products! Can I add a new
            place or product to Thruhike?
          </span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          Yes! We love learning about your favorite places and products. The
          best way to do this is to go into Product/Place on the account
          dropdown and click “Add Product/Place.” Fill in the relevant
          information and a member of our team will review the business to make
          sure they meet Thruhike’s vendor guidelines before adding it to our
          site.
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">I want better place and product suggestions</span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          Our team works hard to curate places and products that match your
          tastes and preferences. Sometimes we don’t hit the nail on the head -
          after all, we’re human. To better your experience, fill out the “About
          Me” in “View Profile” in your account dropdown and continue to
          interact with our site so we get to know you better. Plus, we will
          send out occasional quizzes to get to know you better. Also, feel free
          to check out our Consumer Subscription packages for a truly
          personalized concierge experience.
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&gt; Subscriptions FAQ</span>
        </b>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">
            Can you customize a Trail List for me for an upcoming trip? Can you
            assist with booking my vacation? Can you help with my holiday
            shopping?{" "}
          </span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          While our platform is free, our aim is to give you the best
          experiences on the computer and in the real world. We have a number of
          subscription packages for our consumers that help you plan vacations,
          shop for loved ones, and give you the VIP concierge experience for a
          fraction of the cost of a travel agent. For more information click
          “Custom Trail Lists” or “Thruhike Concierge” on your account dropdown
          menu.&nbsp; If you want a whole package of services i.e. custom Trail
          Lists and a Thruhike Concierge, check out Subscriptions on your
          account dropdown page to learn more.
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">What if I have questions about my subscription?</span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          You’re always welcome to contact us at{" "}
          <a href="mailto:subscriptions@gothruhike.com">
            <span style={{ color: "#1155CC" }}>
              subscriptions@gothruhike.com
            </span>
          </a>
          . If you have an active subscription, you’ll also have the contact
          information of a dedicated concierge at the company who is available
          to help.
        </span>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&nbsp;</span>
        </b>
      </p>

      <div className="MsoNormal" align="center" style={{ textAlign: "center" }}>
        <span lang="EN">
          <hr size="2" width="100%" align="center" />
        </span>
      </div>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&nbsp;</span>
        </b>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&nbsp;</span>
        </b>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">Thruhike for Business</span>
        </b>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&gt; General FAQ</span>
        </b>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">How do I claim my business?</span>
        </i>
      </p>

      <ol style={{ marginTop: "0in" }} start="1" type="1">
        <li className="MsoNormal">
          <span lang="EN">
            Your general business email should have received an email with
            instructions once your place or product is selected for our site. If
            not, search for your place or product on our platform.
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Click into the profile for your place or product
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Click the “Claim the Business” button on that profile page and
            submit the requested information
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Once your claim is approved (in ~24-48 hours), you’ll be able to
            access* and make updates to your place or product profile
          </span>
        </li>
      </ol>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          *Please note - you can claim your business without signing in however,
          you must be signed in with the email you used to claim that business
          to make any updates to that profile
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">How do I edit my place or product profile?</span>
        </i>
      </p>

      <ol style={{ marginTop: "0in" }} start="1" type="1">
        <li className="MsoNormal">
          <span lang="EN">
            Once you’ve claimed your place or product profile, sign into your
            account{" "}
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Go to the profile page you would like to edit and click the “Edit”
            Icon
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Fill in any information you would like to update and save
          </span>
        </li>
        <li className="MsoNormal">
          <span lang="EN">
            Profile updates (i.e. status updates out to your customers) will be
            posted instantly however, any other profile changes will be approved
            by our curation team within 24-48 hours
          </span>
        </li>
      </ol>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&nbsp;</span>
        </b>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">
            How do you curate the places and products on your site?
          </span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          It’s a little bit like Grandma’s secret tomato sauce recipe. We have a
          checklist of key ingredients that are reviewed by our Curation and
          Scout team before a place or product is selected for our site. This
          includes quality, vibe, story, customer feedback, and commitment to
          community. That being said, we are always excited to learn about new
          places and products so feel free to go to the “Product/Place” section
          of your account dropdown and click “Add Product/Place” to submit a new
          business for review. This is especially important for owners with
          upcoming business openings that we may have missed!
        </span>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&nbsp;</span>
        </b>
      </p>

      <p className="MsoNormal">
        <b>
          <span lang="EN">&gt; Subscriptions FAQ</span>
        </b>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">
            What’s the benefit of having a business subscription when your
            platform is free?
          </span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          Yes, our platform is free and you can update your profile and interact
          with our site whenever you want. Our goal is to help local businesses!{" "}
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          However, we do have invaluable tools in our subscriptions that support
          your business and strengthen your marketing and branding. Some of our
          offerings include 1) an analytics dashboard to deepen personalization
          for your customers and scale your business, 2) a quarterly and/or
          yearly report that analyzes your business in relation to the industry
          you’re in and provides expert suggestions from hospitality and product
          consultants, and 3) professional grade video content for a fraction of
          the price. Check out Subscriptions on your account dropdown page to
          learn more.
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">
            Does my business have to be an approved vendor on your platform to
            subscribe?
          </span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          Not at all - we’d love to work with you and your business whether you
          are selected for our platform or not. In fact, we love working with up
          and coming places and products. What’s more exciting than that?!
        </span>
      </p>

      <p className="MsoNormal">
        <span lang="EN">&nbsp;</span>
      </p>

      <p className="MsoNormal">
        <i>
          <span lang="EN">What if I have questions about my subscription?</span>
        </i>
      </p>

      <p className="MsoNormal">
        <span lang="EN">
          You’re always welcome to contact us at{" "}
          <a href="mailto:subscriptions@gothruhike.com">
            <span style={{ color: "#1155CC" }}>
              subscriptions@gothruhike.com
            </span>
          </a>
          . If you have an active subscription, you’ll also have the contact
          information of a dedicated concierge at the company who is available
          to help.
        </span>
      </p>
    </div>
  );
};
